import React from 'react';
import { Row, Col } from 'bootstrap';
import { OrderedMap, fromJS } from 'immutable';
import RouteActions from 'flux/actions/RouteActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CueClock from 'main/components/show/cuesheet/cueClock.jsx';
import EventClock from 'shared/components/event/clock.jsx';
import ViewMenu from 'main/components/show/cuesheet/viewMenu.jsx';
import ListHeader from 'main/components/show/cuesheet.displayView/listHeader.jsx';
import ShowsMenu from 'shared/components/menus/shows.jsx';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import { PageHeaderHeight } from 'shared/flux/stores/cuesheet.fullscreen/DisplayViewConstants';
import { DisplayTypes } from 'shared/constants/FlowConstants';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

class PageHeader extends React.Component {
  constructor(props) {
    super(props);
    this._getHeaderShowMenu = this._getHeaderShowMenu.bind(this);
    this._getHeaderMiscOptions = this._getHeaderMiscOptions.bind(this);
  }

  render() {
    const { columns, columnId, showOnboarding, user } = this.props;

    return (
      <div id="display-view-header" className="container">
        <Row
          style={{ height: PageHeaderHeight }}
          className="page-header-row disable-text-highlight"
        >
          {this._getHeaderShowMenu()}
          {_getHeaderClocks()}
          {this._getHeaderMiscOptions()}
        </Row>
        <ListHeader
          user={user}
          showOnboarding={showOnboarding}
          columns={columns}
          columnId={columnId}
        />
      </div>
    );
  }

  _getHeaderShowMenu() {
    const { eventId, teamId, event, show } = this.props;

    if (!event || !show) return null;

    const cols = {
      xs: 14,
      sm: 11,
      smOffset: 1,
      md: 11,
      mdOffset: 1,
      lg: 12,
      lgOffset: 1,
    };

    return (
      <Col {...cols} className="title-wrapper">
        <div
          className="event-title"
          onClick={() => RouteActions.goToEvent({ teamId, eventId })}
        >
          {event.title}
        </div>
        {this._getShowMenu()}
      </Col>
    );
  }

  _getShowMenu() {
    const { showId, eventId, teamId, shows } = this.props;

    if (!shows || !shows.size || !showId) return null;

    let showsMap = OrderedMap({});

    shows.forEach((show) => {
      const displayType = show.get('displayType');
      if (
        displayType === DisplayTypes.list ||
        displayType === DisplayTypes.schedule
      )
        return;
      showsMap = showsMap.set(show.get('_id'), show);
    });

    return (
      <div>
        <ShowsMenu
          shows={showsMap}
          activeId={showId}
          onChange={(show) =>
            RouteActions.goToDisplayView({
              teamId,
              eventId,
              showId: show.get('_id'),
            })
          }
        />
      </div>
    );
  }

  _getHeaderMiscOptions() {
    const toolsColumns = { md: 2, lg: 2 };

    const {
      teamId,
      eventId,
      showId,
      user,
      onToggleFullScreenMode,
      fullScreenEnabled,
      team,
      event,
    } = this.props;

    const viewSwitcherNode = (
      <ViewMenu
        {...{
          teamId,
          eventId,
          showId,
          user,
          team: fromJS(team),
          event: fromJS(event),
        }}
      />
    );

    const { EnterFullscreen, ExitFullscreen } = TooltipConstants;

    const tip = fullScreenEnabled ? ExitFullscreen : EnterFullscreen;

    return (
      <Col {...toolsColumns} className="hidden-xs hidden-sm icon-buttons">
        {viewSwitcherNode}
        <span className="fullscreen-action-button-wrapper">
          <WithTooltip delay={0} tip={tip} placement="bottom">
            <span className="fullscreen-action">
              <Icon name="arrows-alt" onClick={onToggleFullScreenMode} />
            </span>
          </WithTooltip>
        </span>
      </Col>
    );
  }
}

function _getHeaderClocks() {
  const clocksCols = { xs: 10, sm: 11, md: 9, lg: 8 };

  return (
    <Col {...clocksCols} className="clocks-wrapper">
      <CueClock hideDescription fullScreen={false} />
      <EventClock hideDescription />
    </Col>
  );
}

export default PageHeader;
